/** Which actions a /clips card shows, and where.
 *
 *  The card has two buttons next to "Baixar": the second one is Postar when
 *  the clip can be posted, otherwise Editar. Everything else lives in the
 *  "⋯" menu, in three groups: editing, extras, rating. */

export type ClipCardSecondaryAction = 'post' | 'edit' | null;

export function resolveClipCardSecondaryAction({
  canPost,
  canEdit,
}: {
  canPost: boolean;
  canEdit: boolean;
}): ClipCardSecondaryAction {
  if (canPost) return 'post';
  if (canEdit) return 'edit';
  return null;
}

export type ClipCardMenuItem =
  | 'edit'
  | 'editWithAi'
  | 'studio'
  | 'carousel'
  | 'cover'
  | 'titles'
  | 'share'
  | 'rating';

export interface ClipCardMenuInput {
  secondary: ClipCardSecondaryAction;
  canEdit: boolean;
  canEditWithAi: boolean;
  canOpenStudio: boolean;
  canMakeCarousel: boolean;
  canSetCover: boolean;
  canGenerateTitles: boolean;
  canShare: boolean;
  canRate: boolean;
}

/** Menu groups in display order; unavailable items and empty groups are dropped. */
export function buildClipCardMenu(input: ClipCardMenuInput): ClipCardMenuItem[][] {
  const groups: Array<Array<[ClipCardMenuItem, boolean]>> = [
    [
      ['edit', input.canEdit && input.secondary !== 'edit'],
      ['editWithAi', input.canEditWithAi],
      ['studio', input.canOpenStudio],
      ['carousel', input.canMakeCarousel],
    ],
    [
      ['cover', input.canSetCover],
      ['titles', input.canGenerateTitles],
      ['share', input.canShare],
    ],
    [['rating', input.canRate]],
  ];
  return groups
    .map((group) => group.filter(([, shown]) => shown).map(([item]) => item))
    .filter((group) => group.length > 0);
}
